import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

interface PropTypes
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  customEmoji?: string;
  customEmojiLabel?: string;
  dataTest?: string;
  hasEmoji?: boolean;
  messageId?: string;
  messageValues?: Record<string, any>;
  type?: 'error' | 'info' | 'warning';
}

/**
 * Component used to communicate information or warnings to the user
 */
const InfoBar: React.FC<React.PropsWithChildren<PropTypes>> = ({
  customEmoji,
  customEmojiLabel,
  dataTest,
  messageId,
  messageValues,
  type = 'info',
  children,
  className,
  hasEmoji = true,
  ...others
}) => (
  <div
    className={cn(
      'mb-2.5 flex items-center rounded-lg p-2 text-sm',
      type === 'info' && 'bg-blue-50 text-blue-600',
      type === 'warning' && 'bg-orange-50 text-orange-700',
      type === 'error' && 'bg-red-50 text-red-600',
      className
    )}
    data-test={dataTest}
    {...others}
  >
    {type === 'warning' && hasEmoji && (
      <span role="img" aria-label="Warning Emoji" className="mr-2">
        ⚠️
      </span>
    )}
    {type === 'error' && (
      <span role="img" aria-label="No Entry Emoji" className="mr-2">
        ⛔️
      </span>
    )}
    {customEmoji && (
      <span role="img" aria-label={customEmojiLabel} className="mr-2">
        {customEmoji}
      </span>
    )}
    {children ? (
      <>{children}</>
    ) : (
      <FormattedMessage id={messageId} values={messageValues} />
    )}
  </div>
);

export default InfoBar;
